export default __webpack_public_path__ + "media/Seasoning-Honey.366b72d6.png";